<template>
    <div class="detail-info" :class="{ 'open-read-more': openReadMore }">
        <Provided
            v-if="positionProvided && positionProvided === PROVIDED_POSITION_KEY.top"
            theme="standard"
        />
        <!-- other components between Provided top and Provided above -->
        <Provided
           v-if="positionProvided && positionProvided === PROVIDED_POSITION_KEY.above"
            theme="standard"
        />
        <DetailInfoHeader></DetailInfoHeader>
        <DetailInfoGroup @refresh-parent="calcShowReadMore"></DetailInfoGroup>
        <p class="read-more" v-if="showReadMore" @click="onReadMore">
            <span>{{
                openReadMore
                    ? $t('md-detail-info.readLess')
                    : $t('md-detail-info.readMore')
            }}</span>
        </p>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore } from '@/store';
import util from '@/common/util';
import DetailInfoHeader from './detail-info-header/index.vue';
import DetailInfoGroup from '../detail-info-group.vue';
import Provided from '../provided';
import { PROVIDED_POSITION_KEY } from '@/common/mls';

export default {
    emits: ['readMore'],
    i18next: {
        ns: 'md-detail-info'
    },
    components: { DetailInfoHeader, DetailInfoGroup, Provided },
    inject: ['readMore'],
    props: {
        positionProvided: String,
        isapp: {
            type: Boolean,
            required: true
        }
    },
    data: function() {
        return {
            PROVIDED_POSITION_KEY,
            agentInfo: {},
            showReadMore: false
        };
    },
    mounted() {
        this.calcShowReadMore();
    },
    methods: {
        calcShowReadMore() {
            if (util.isSSRServer) {
                return; 
            }
            this.$nextTick(() => {
                if (
                    this.$el.offsetHeight < this.$el.scrollHeight &&
                    !this.openReadMore
                ) {
                    this.showReadMore = true;
                }
                if (this.$el.offsetHeight > 640 && this.openReadMore) {
                    this.showReadMore = true;
                }
            });
        },
        onReadMore() {
            this.readMore(() => {
                if (!this.openReadMore) {
                    this.$nextTick(() => {
                        this.$el.scrollIntoView();
                    });
                }
                setTimeout(() => {
                    this.$emit('readMore');
                }, 0);
            });
        }
    },
    computed: {
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        ...mapState({
            "listingDetail": "listingDetail",
            "triggerReadMore": "triggerReadMore",
            "openReadMore": "openReadMore"
        }),
        
        
        info() {
            return this.listingDetail.info;
        },
        daysOnSite() {
            return this.listingDetail.daysOnSite || 10;
        },

        showShare() {
            return (
                this.listingDetail.facebookHref ||
                this.listingDetail.twitterHref ||
                this.listingDetail.linkedinHref
            );
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-detail-info.standard {
    .detail-info {
        overflow: hidden;
        position: relative;
        max-height: 640px;
        &.open-read-more {
            max-height: none;
            .read-more {
                position: static;
                &::before {
                    display: none;
                }
            }
        }
        &.more,
        &.show-all {
            height: auto;
        }

        .read-more {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            background: #fff;
            padding-top: 10px;
            @include color-theme();
            text-align: center;
            text-decoration: underline;
            cursor: pointer;
            font-size: 16px;
            &::before {
                content: '';
                display: block;
                position: absolute;
                bottom: 100%;
                height: 20px;
                background-image: linear-gradient(
                    to bottom,
                    rgba(255, 255, 255, 0),
                    #fff
                );
                width: 100%;
            }
        }
        &.show-all {
            .read-more {
                display: none;
            }
        }
        .fix-wrap {
            display: none;
        }
    }
    @include media-1280 {
        .detail-info {
            max-height: 710px;
            .no-margin-top-pre-next {
                margin-top: 0;
            }
            .no-margin-top-pre-next {
                margin-top: 0;
            }
        }
    }

    @include media-800 {
        .detail-info {
            margin-top: 20px;
        }
        .read-more {
            padding-bottom: 10px;
        }
    }
}
</style>
